//@flow
import React from "react";
// import ListenLiveBanner from "./listen-live-banner";
// import PlayPodcastBanner from "./listen-live-banner/podcastbanner";
import fluxfix from "../services/fluxfix";
import Menu from "./menu";
// import NowPlaying from "./now-playing/now-playing";
// $FlowFixMe
import css from "./radioplayer.module.scss";
import Store from "../services/store";
import { Container } from "flux/utils";
import { Actions } from "../services/actions";
// import Logo from "../img/logowhite.png";
// import SocialIcons from "./social-icons/social-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";

import AudioPlayer from "./audioplayer-v2";
import Adverts from "./adverts/adverts";
import Footer from "./footer";
import ListenAgain from "./listenagain/listen-again";
import { AudioSource, SourceType } from "./audioplayer-v2/source";
import { makeLanseURL } from "../lib/makeLanseURL";
// import Loading from "../lib/loading";
import { endSession } from "./audioplayer-v2/sessionReporting";

// import Sponsor from "./sponsor/sponsor";
import Stations from "./stations/stations";
// import StationSingle from "./stations/station-single";
// import PlayerActions from "./audioplayer-v2/playerControl";
import { split, HttpLink } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { WebSocketLink } from "@apollo/client/link/ws";
import { isMobileSafari } from 'react-device-detect';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  // useQuery, gql
} from "@apollo/client";

// previous live url
// window.STREAM_URL = "https://d1rfbg9t3vyscr.cloudfront.net/stream/index.m3u8";

// new live url bypassing cloudfront
// window.STREAM_URL = "https://livestream.indemandradio.com/stream/index.m3u8";

// only used to provide a link
// window.STREAM_URL_ICECAST = "http://idr-nlb-400b0b217a490f14.elb.eu-west-1.amazonaws.com:8001/in_demand_radio";
// window.STREAM_URL_ICECAST = "https://indemandradio.com/in_demand_radio";

// direct to s3
// window.LANSE_SERVER = "https://s3-eu-west-1.amazonaws.com/lance.indemandradio.com/";

// window.LANSE_SERVER = "https://d1kdm27179b81p.cloudfront.net/";

const wsLink = new WebSocketLink({
  uri: "wss://gql.indemandradio.com/gql/query",
  // uri: 'ws://localhost/gql/query',

  options: {
    reconnect: true,
    timeout: 60000,
    inactivityTimeout: 0 
  },
});
const httpLink = new HttpLink({
  uri: "https://gql.indemandradio.com/gql/query",
  // uri: "http://127.0.0.1/gql/query"
});
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === "OperationDefinition" && definition.operation === "subscription";
  },
  wsLink,
  httpLink
);

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

type Props = {};
type State = {
  store: Object,
};

const betaMode = localStorage.getItem("betaMode")==="1";
class RadioPlayer extends React.Component<Props, State> {
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return { store: Store.getState() };
  }
  firstLoad: boolean = true;

  urlRCID: ?string;
  componentWillMount() {
    // Actions.fetchPodcasts();
    // Actions.fetchAdverts();
    // Actions.fetchStations();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.urlRCID = urlParams.get("rcid");
    // this.setState({ enableBeta: urlParams.get("enablebeta") === "true" });

    if (this.urlRCID) {
      const src = new AudioSource();
      src.id = this.urlRCID;
      src.src = makeLanseURL(this.urlRCID);
      src.srctype = SourceType.HLS;
      src.isLiveStream = false;
      Actions.setCurrentSrc(src);

      setTimeout(() => {
        Actions.setDesiredPlayState(true);
      }, 1000);
    }

    window.addEventListener(
      "beforeunload",
      function (event) {
        endSession();
      },
      false
    );
  }
  componentWillUnmount() {
    endSession();
  }
  render() {
    // const metadata = this.state.store.get("nowOn");
    // const podcasts = this.state.store.get("podcasts");
    // const stations = this.state.store.get("stations");

    // const ds = new AudioSource();
    if (this.urlRCID) {
      // const src = new AudioSource();
      // src.src = makeLanseURL(this.urlRCID)
      // src.id = this.urlRCID;
      // src.srctype = SourceType.HLS;
      // src.isLiveStream = false;
      // Actions.setCurrentSrc(src);
      // Actions.setDesiredPlayState(true)
    } else {
      // if (stations && this.firstLoad) {
      //   this.firstLoad = false;
      //   const src = new AudioSource();
      //   src.src = stations["IDR1"].hlsURL;
      //   src.title = stations["IDR1"].name;
      //   src.description = stations["IDR1"].shortDescription;
      //   src.srctype = SourceType.HLS;
      //   src.img = stations["IDR1"].headerImage;
      //   src.isLiveStream = true;
      //   src.stationID = stations["IDR1"].stationID;
      //   setTimeout(() => PlayerActions.playSource(src), 1000);
      // }
    }

    return (
      <ApolloProvider client={client}>
        <div className={css.page}>
          <div className={css.container}>
            <DeviceMessage/>
           <Stations betaMode={betaMode}/>
            <Adverts />
            <Explore />
            <ListenAgain />
            <Menu />
            <Footer />
            <AudioPlayer />
          </div>
        </div>
      </ApolloProvider>
    );
  }
}
export default (Container.create(fluxfix.convert(RadioPlayer)): Object);

const DeviceMessage =():Object=>{
  if(isMobileSafari)return <div className={css.deviceMessage}>iOS is not fully compatible with this web player. You may experience problems with audio playback! Please check out our iOS app on the App Store</div>
  return null;
}


const Explore = () => {
  return (
    <div className={css.explore}>
      <a href="https://idrad.io" target="_blank" rel="noopener noreferrer">
        <div>
          <span className={css.explore}>EXPLORE MORE</span>
          &nbsp;
          <span className={css.idr}>In Demand Radio</span>
        </div>
        <div className={css.icon}>
          <FontAwesomeIcon icon={faArrowCircleRight} />
        </div>
      </a>
    </div>
  );
};